import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="video-sound"
export default class extends Controller {
  static targets = ["player", "muteIcon", "unmuteIcon"];

  toggle(event) {
    // Prevent the click from triggering links underneath or around the button
    event.preventDefault();
    event.stopPropagation();

    if (this.playerTarget.muted) {
      this.playerTarget.muted = false;
      this.muteIconTarget.classList.add("hidden");
      this.unmuteIconTarget.classList.remove("hidden");
    } else {
      this.playerTarget.muted = true;
      this.unmuteIconTarget.classList.add("hidden");
      this.muteIconTarget.classList.remove("hidden");
    }
  }
}
